import Fetcher from "../utils/Fetcher";
import Consts from "../commons/Consts";

export const InvoicesService = {
    initialize(data) {
        return Fetcher.post(`${Consts.baseapi}/invoices/initialize`, data);
    },

    checkInvoiceStatus(token) {
        return Fetcher.get(`${Consts.baseapi}/invoices/${token}/check-status`);
    },

    updateInvoiceStatus(token, status) {
        return Fetcher.put(`${Consts.baseapi}/invoices/${token}/update-status`, { status });
    }
};
